if (!customElements.get('parcel-delivery-estimate')) {
  customElements.define(
    'parcel-delivery-estimate',
    class ParcelDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-delivery-form]');
        this.input = this.form?.elements.postcode;
        this.result = this.querySelector('[data-delivery-result]');

        if (!this.form || !this.input || !this.result) return;

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (this.input.value.length === 4) this.showEstimate();
        });

        this.input.addEventListener('input', () => {
          this.input.value = this.input.value.replace(/\D/g, '').slice(0, 4);
          if (this.input.value.length === 4) {
            this.showEstimate();
          } else {
            this.result.hidden = true;
            this.result.textContent = '';
          }
        });
      }

      showEstimate() {
        const postcode = Number(this.input.value);

        const days = this.getDeliveryWindow(postcode);
        this.result.textContent = days
          ? this.dataset.resultTemplate.replace('[days]', days)
          : this.dataset.fallback;
        this.result.hidden = false;
      }

      getDeliveryWindow(postcode) {
        const regions = [
          { ranges: [[1000, 1920], [2000, 2239], [2555, 2574], [2740, 2786]], days: '5–6' },
          { ranges: [[2250, 2483], [2500, 2551], [2575, 2594], [2621, 2647], [2649, 2714], [2716, 2716], [2720, 2730], [2787, 2880]], days: '5–7' },
          { ranges: [[200, 250], [2600, 2620], [2900, 2914]], days: '4–6' },
          { ranges: [[3000, 3207], [3335, 3341], [3427, 3442], [3750, 3810], [3910, 3920], [3926, 3944], [3975, 3978], [3980, 3981], [8000, 8785]], days: '5–8' },
          { ranges: [[2648, 2648], [2715, 2715], [2717, 2717], [2731, 2739], [3211, 3334], [3342, 3424], [3444, 3749], [3812, 3909], [3921, 3925], [3945, 3971], [3979, 3979], [3984, 3996]], days: '6–9' },
          { ranges: [[2484, 2490], [4000, 4370], [4373, 4381], [4400, 4405], [4500, 4580], [4600, 4610], [4614, 4615], [9016, 9464], [9726, 9726]], days: '6–8' },
          { ranges: [[4371, 4372], [4382, 4390], [4406, 4498], [4581, 4581], [4611, 4613], [4620, 4723]], days: '4–7' },
          { ranges: [[4724, 4870], [4872, 4873], [4877, 4888]], days: '6–9' },
          { ranges: [[4871, 4871], [4890, 4895]], days: '9–11' },
          { ranges: [[4874, 4876]], days: '11–17' },
          { ranges: [[5000, 5171], [5800, 5950]], days: '5–7' },
          { ranges: [[5201, 5734]], days: '5–8' },
          { ranges: [[6000, 6214], [6800, 6997]], days: '7–10' },
          { ranges: [[6215, 6646]], days: '7–11' },
          { ranges: [[6701, 6770]], days: '10–13' },
          { ranges: [[7000, 7254], [7258, 7923]], days: '6–9' },
          { ranges: [[7255, 7257]], days: '7–11' },
          { ranges: [[800, 821], [828, 834]], days: '7–11' },
          { ranges: [[870, 871]], days: '7–12' },
          { ranges: [[822, 822], [835, 862], [872, 875], [880, 881], [885, 909]], days: '14–17' },
        ];

        return regions.find((region) =>
          region.ranges.some(([start, end]) => postcode >= start && postcode <= end)
        )?.days;
      }
    }
  );
}
